export default "__VITE_ASSET__ccVDuXrY__"